// React Component
import React from 'react'
import { useTranslation } from 'react-i18next'

// App Component
import { NewProcessOrGroupV2, Spiner, UnifiedCard } from '../../components'
import { AppLayout, HeaderLayout, ProcessLayoutV2 } from '../../layouts'
import { FamlaServices } from '../../services'
import { useAppSelector } from '../../stores'
import { useMappingAccessNavigation } from '../../hooks/useMappingAccessNavigation'
import { parseMappingRoute } from '../../utils/mappingAccess'

//Interface
import { Routes } from '../../routes'

const AnalysisView = () => {
    const users = useAppSelector((state) => state.auth);
    const companyId = users.session.company_id;
    const { t } = useTranslation();
    const { openMapping, creditsModal } = useMappingAccessNavigation();
    const language = localStorage.getItem('currentLanguage') === "fr" ? "french" : "english"


    const [state, setState] = React.useState({
        isLoadingReport: true,
        error: '',
        popularUseCase: [],
        reports: []

    })


    React.useEffect(() => {

        const loadReportsAnalysis = async () => {
            try {
                let data = await FamlaServices("api_host", `/report/all/report/${companyId}`, "GET", "", users.access_token);
                if (data.status === 200) {
                    setState((prev) => ({ ...prev, reports: data.body.data, isLoadingReport: false }));
                } else {
                    setState((prev) => ({ ...prev, isLoadingReport: false, error: 'Failed to fetch data' }));
                }
            } catch (error: any) {
                setState((prev) => ({ ...prev, isLoadingReport: false, error: error.message }));
            }
        }

        loadReportsAnalysis();

    }, [language, users.access_token])



    return (
        <AppLayout>
            <>
                {creditsModal}
                <HeaderLayout loadcompany={false} />

                <ProcessLayoutV2
                    title={t('words.analysis')}
                    arrowBack={true}
                    style={{ marginLeft: '6%' }}
                    classNameWrapper='justify-content-start'
                    route={Routes.PROCESSLIBRARY}
                >
                    {state.isLoadingReport ?
                        <Spiner className='ms-5 spinner-border-sm' /> :
                        <>
                            {state.reports.map((report: any) => {
                                const mappingRoute = Routes.MAPPING + `${report.analyse.process_id}/${report.analyse.map_id}/${report.analyse._id}`;
                                return (
                                    <UnifiedCard
                                        processName={report.analyse.name}
                                        thisProcessHasABadge={false}
                                        theBadgeHasAValue={false}
                                        badgeValue={0}
                                        thisProcessHasAOwner={false}
                                        owner=''
                                        key={report._id}
                                        route={mappingRoute}
                                        onClick={() => {
                                            const parsed = parseMappingRoute(mappingRoute);
                                            if (!parsed) return;
                                            void openMapping({
                                                processId: parsed.processId,
                                                mapId: parsed.mapId,
                                                analysisId: parsed.analysisId,
                                            });
                                        }}
                                        deleteProcess={() => { }}
                                        description={report.name}
                                        processId=''
                                        folder={false}
                                        setProject={() => { }}
                                        usage={'populare'}
                                        setProcess={() => { }}
                                        elementType='popular'
                                        t={t}

                                    />
                                )
                            })}
                            {(!state.isLoadingReport && state.reports.length === 0) &&
                                <NewProcessOrGroupV2
                                    newElement={t('views.processView.reportNotFound')}
                                    create='process'
                                    noResult={true}
                                />
                            }
                        </>
                    }

                </ProcessLayoutV2>
            </>
        </AppLayout>
    )
}

export default AnalysisView